import React from "react";
import { setSelected } from "../redux/eventLogsSaga";
import { useDispatch, useSelector } from "react-redux";

import { CInput } from "@coreui/react";

const SearchFilter = () => {
  const dispatch = useDispatch();
  const searchValue = useSelector((state) => state.eventLogs.selected.search);

  const onInputChange = (title, key) => {
    dispatch(setSelected({ [key]: title }));
  };

  return (
    <>
      <CInput
        onChange={(e) => onInputChange(e.target.value, "search")}
        className="text-input"
        type="text"
        placeholder="Enter your query"
        value={searchValue}
      />
    </>
  );
};

export default SearchFilter;
